export default "__VITE_ASSET__83ea4e8c__"